export default "__VITE_ASSET__D86DS3YV__"